import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import { messages } from "./locales/index.js";
import { GettyUICore, GettyUIForms } from "@thegetty-private/getty-ui";
import { createHead } from "@unhead/vue/client";
import { i18n } from "@/i18n";
import { appSupport } from "@thegetty-private/rad-app-utils";

const app = createApp(App);

appSupport.setupSentry(app, "pubhub", process.env.VUE_APP_COMMIT_HASH);
// disable default page_view event since this is a SPA
let gtmConfig = {
  send_page_view: false
};

appSupport.setupGoogleAnalytics(app, undefined, true, gtmConfig);
app.use(router);

const head = createHead();
app.use(head);

app.use(GettyUICore, {
  i18nConfig: {
    locale: "en",
    fallbackLocale: "en",
    messages: messages
  }
});
app.use(GettyUIForms);

const pinia = createPinia();
pinia.use(({ store }) => {
  store.i18n = i18n;
});
app.use(pinia);

app.mount("#app");
